import {ObjectDTO} from "./object-dto";

export class RegimeAlimentaireDTO  extends ObjectDTO{

  code: string;
  libelle: string;
  actif: boolean;

}
